/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Wealthlane_AwardService_Notices_NoticeType {
    '_1' = 1,
}
